export default __webpack_public_path__ + "static/media/contact-us-classic-03.c9ca1497.jpg";